var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"roles"},[(_vm.initialized && _vm.contextIsReady(_vm.context))?_c('admin-roles',_vm._b({attrs:{"links":_vm.rolesLinks}},'admin-roles',_vm.roles,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }